import React from 'react';
import classNames from 'classnames';
import FormWithValidations from 'components/form-with-validations';
import styles from './styles.module.scss';
import emailRegex from 'utils/emailRegex';

const validations = {
  name: value => Boolean(value),
  email: value => emailRegex.test(value),
};

class FormContact extends React.Component {
  render() {
    const {
      fields,
      errors,
      handleSubmit,
      handleChange,
      success,
      showHeader,
      showSubtext,
      messageLabel,
    } = this.props;

    const { name, email, message } = fields;

    return (
      <React.Fragment>
        {showHeader && <h2 className={styles.header}>Contact Unyted</h2>}
        {showSubtext && (
          <p className={styles.supportingText}>GET MORE INFO AND SUPPORT</p>
        )}
        <form className={styles.contactForm} onSubmit={handleSubmit}>
          {success && (
            <div className="alert alert-apple">
              <h2>Thanks for your enthusiasm and reaching out!</h2>
              <p>We'll respond to you immediately!</p>
            </div>
          )}
          <div
            className={classNames({
              'form-group': true,
              [styles.error]: errors.name,
              [styles.formGroup]: true,
            })}
          >
            <label htmlFor="name">Name*</label>
            <input
              name="name"
              type="text"
              className="form-control"
              id="name"
              onChange={handleChange}
              value={name}
            />
            <p>Name is required</p>
          </div>
          <div
            className={classNames({
              'form-group': true,
              [styles.error]: errors.email,
              [styles.formGroup]: true,
            })}
          >
            <label htmlFor="email">Email*</label>
            <input
              name="email"
              type="email"
              className="form-control"
              id="email"
              onChange={handleChange}
              value={email}
            />
            <p>Invalid email format</p>
          </div>
          <div className={`form-group ${styles.formGroup}`}>
            <label htmlFor="message">
              {messageLabel
                ? messageLabel
                : 'School, Grade Level and Subject Matter'}
            </label>
            <textarea
              name="message"
              className="form-control"
              onChange={handleChange}
              rows="1"
              value={message}
            />
          </div>
          <p className={styles.required}>* Required</p>
          <button type="submit" className={styles.submitButton}>
            Submit
          </button>
        </form>
      </React.Fragment>
    );
  }
}

const ValidatedFormContact = FormWithValidations(
  FormContact,
  { name: '', email: '', message: '' },
  validations,
);

export default ValidatedFormContact;
